import { detect } from 'detect-browser'
import { useEffect, useState } from 'react'
import { isMobile } from 'react-device-detect'
import {
  getFishingProfile,
  getProfileImage,
  postCheckEmail,
  postCheckNickname,
  postKakaoSocialConnect,
  postKakaoSocialDisconnect,
  postKakaoSocialLogin,
  postRefresh,
  postUpdateUser,
} from '../../api/login'
import MyShoppingSideBar from '../../components/myshopping/MyShoppingSideBar'
import PhoneChangeCenterModal from '../../components/myshopping/PhoneChangeCenterModal'
import PhoneChangeModal from '../../components/myshopping/PhoneChangeModal'
import { PictureCenterModal } from '../../components/myshopping/PictureCenterModal'
import { PictureModal } from '../../components/myshopping/PictureModal'
import WithdrawalCenterModal from '../../components/myshopping/WithdrawalCenterModal'
import WithdrawalModal from '../../components/myshopping/WithdrawalModal'
import { useCommonContext } from '../../components/provider/CommonProvider'
import { useMyContext } from '../../components/provider/MyProvider'
import { PageTitle } from '../../components/title/PageTitle'
import '../../css/Member.css'
import { postOpenid } from '../../api/auth'
import { useNavigate } from 'react-router-dom'

export default function Profile() {
  const [pictureModal, setPictureModal] = useState<boolean>(false)
  const [nickName, setNickName] = useState<string>('')
  const [email, setEmail] = useState<string>('')
  const [myIntro, setMyIntro] = useState<string>('')
  const [website, setWebsite] = useState<string>('')
  const [phone, setPhone] = useState<string>('')
  const [profileImages, setProfileImages] = useState<any>([])
  const [selectImage, setSelectImage] = useState<string>('')
  const [os, setOs] = useState<any>()
  const [profileImage, setProfileImage] = useState<any>()
  const [phoneChangeModal, setPhoneChangeModal] = useState<any>()
  const [verificationCheckCode, setVerificationCheckCode] = useState<any>()
  const [withdrawal, setWithdrawal] = useState<boolean>(false)
  const [nicknameCheck, setNicknameCheck] = useState<boolean>(false)
  const [emailCheck, setEmailCheck] = useState<boolean>(false)
  const [websiteCheck, setWebsiteCheck] = useState<boolean>(false)
  const [originProfileData, setOriginProfileData] = useState<any>(null)
  const [isModifyReady, setIsModifyReady] = useState<boolean>(false)
  const [kakaoConnect, setKakaoConnect] = useState<boolean>(false)
  const navigate = useNavigate()

  const { setToastMessage, setIsToast } = useMyContext()
  const { setIsLottie, hasAccessToken } = useCommonContext()

  useEffect(() => {
    if (originProfileData !== null) {
      if (
        originProfileData.nickName !== nickName || selectImage !== undefined
          ? originProfileData.profileImage !== selectImage
          : originProfileData.profileImage !== profileImage ||
            originProfileData.email !== email ||
            originProfileData.biography !== myIntro ||
            originProfileData.website !== website ||
            originProfileData.mobilePhone !== phone
      ) {
        if (nicknameCheck || emailCheck || websiteCheck) {
          setIsModifyReady(false)
          return
        }
        setIsModifyReady(true)
      } else {
        setIsModifyReady(false)
      }
    }
  }, [
    originProfileData,
    nickName,
    selectImage,
    email,
    myIntro,
    website,
    phone,
    emailCheck,
    nicknameCheck,
    profileImage,
    websiteCheck,
  ])

  useEffect(() => {
    getProfileImage()
      .then((res) => {
        setProfileImages(res.data)
      })
      .catch((err) => console.log(err))
  }, [])
  useEffect(() => {
    const browerOs = detect()
    setOs(browerOs?.os)
  }, [])

  useEffect(() => {
    if (hasAccessToken) {
      getFishingProfile()
        .then((res) => {
          setOriginProfileData(res.data)
          setIsLottie(false)
          setProfileImage(res.data.profileImage)
          setNickName(res.data.nickName)
          setEmail(res.data.email)
          setPhone(res.data.mobilePhone)
          setMyIntro(res.data.biography ? res.data.biography : '')
          setWebsite(res.data.website ? res.data.website : '')
          const hasValue = res.data.socialLogins.some((item: any) => item.loginType === 'kakao')

          if (hasValue) {
            setKakaoConnect(true)
          }
        })
        .catch((err) => {})
    }
  }, [kakaoConnect])

  useEffect(() => {
    const handleMessage = (event: any) => {
      // 보안 체크: 새 창의 도메인 확인
      if (event.origin !== process.env.REACT_APP_SHOP_URL) return
      if (event.data.kakaoToken && event.data.userData) {
        postKakaoSocialConnect(String(event.data.userData.id), 'kakao')
          .then((res) => {
            setKakaoConnect(true)
            setToastMessage('카카오 로그인 연동이 완료되었어요.')
            setIsToast(true)
          })
          .catch((err) => {
            console.log(err)
          })
      }
    }

    window.addEventListener('message', handleMessage)

    return () => {
      window.removeEventListener('message', handleMessage)
    }
  }, [])

  return (
    <>
      <div className='main_wrap'>
        <div className={isMobile ? 'contents_wrap' : 'contents_wrap sidemenu_wrap'}>
          <MyShoppingSideBar />
          <div className='myshopping_wrap'>
            <PageTitle>프로필 편집</PageTitle>
            <div className='profile_wrap edit'>
              <div className='profile_img_cont profile_edit'>
                <div
                  className='imb_box'
                  onClick={() => {
                    setPictureModal(true)
                  }}
                >
                  <button
                    className='img_fix'
                    style={{
                      width: '100%',
                      height: '100%',
                      backgroundImage: selectImage
                        ? `url(${selectImage})`
                        : profileImage
                        ? `url(${profileImage})`
                        : 'url(../../images/profile_img.png)',
                      backgroundPosition: 'center',
                      backgroundSize: 'cover',
                      borderRadius: '50%',
                      border: 'none',
                      boxShadow: '0 0 0 1px rgba(0, 0, 0, 0.05) inset',
                    }}
                  ></button>
                </div>
              </div>
              <div className='profile_info'>
                <div className='inp_box'>
                  <p style={{ fontSize: '15px', lineHeight: '18px', fontWeight: '500', marginBottom: '20px' }}>
                    SNS 계정 연결 관리
                  </p>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <p
                      style={{
                        fontSize: '16px',
                        lineHeight: '20px',
                        fontWeight: '500',
                        display: 'flex',
                        justifyContent: 'flex-start',
                        alignItems: 'center',
                        gap: '10px',
                      }}
                    >
                      <img src='/images/icon_Kakao.png' alt='' style={{ width: '38px', height: '38px' }} />
                      카카오 계정연결
                    </p>
                    <div className='push-toggle-box' style={{ maxWidth: '50px' }}>
                      <input
                        id='push-toggle'
                        type='checkbox'
                        name='agree_sms'
                        value='disagree'
                        checked={kakaoConnect}
                        onChange={(e) => {
                          if (!kakaoConnect) {
                            const open = window.open('about:blank', '_blank')
                            if (open) {
                              open.location.href = `https://kauth.kakao.com/oauth/authorize?client_id=${process.env.REACT_APP_KAKAO_CLIENT_ID}&redirect_uri=${process.env.REACT_APP_SHOP_URL}/myshopping/oauth&response_type=code`
                            }
                          } else {
                            postKakaoSocialDisconnect('kakao')
                              .then((res) => {
                                console.log(res.data)
                                setKakaoConnect(false)
                              })
                              .catch((err) => {
                                console.log(err)
                              })
                          }

                          // setKakaoAgree((prev) => !prev)
                        }}
                      />
                      <label htmlFor='push-toggle'></label>
                    </div>
                  </div>
                </div>
                <div className='inp_box'>
                  <p style={{ fontSize: '15px', lineHeight: '18px', fontWeight: '500' }}>
                    닉네임
                    {nicknameCheck ? <em>사용할 수 없는 닉네임입니다.</em> : null}
                  </p>
                  <input
                    type='text'
                    placeholder='한글 2자 이상 8자 이하(영문 4byte~16byte)'
                    value={nickName}
                    className='profile_edit'
                    onChange={(e) => {
                      setNickName(e.target.value)
                      const regex = /^([가-힣]{2,8}|[a-zA-Z]{4,16})$/
                      if (regex.test(e.target.value)) {
                        postCheckNickname(e.target.value)
                          .then((res) => {
                            if (res.data.message === 'ok') {
                              setNicknameCheck(false)
                            } else {
                              setNicknameCheck(true)
                            }
                          })
                          .catch((err) => console.log(err))
                      } else {
                        setNicknameCheck(true)
                      }
                      if (e.target.value.length === 0) {
                        setNicknameCheck(false)
                      }
                    }}
                  />
                </div>
                <div className='inp_box'>
                  <p style={{ fontSize: '15px', lineHeight: '18px', fontWeight: '500' }}>
                    이메일
                    {emailCheck ? <em>사용할 수 없는 이메일입니다.</em> : null}
                  </p>
                  <input
                    type='text'
                    placeholder='이메일을 입력해주세요.'
                    value={email}
                    className='profile_edit'
                    onChange={async (e) => {
                      const email = e.target.value
                      setEmail(email)
                      if (email === originProfileData.email) {
                        return
                      }
                      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
                      if (email.length === 0) {
                        setEmailCheck(false)
                        return
                      }
                      if (!emailRegex.test(email)) {
                        setEmailCheck(true)
                        return
                      }
                      try {
                        const res = await postCheckEmail(email)
                        if (res.data.message === 'ok') {
                          setEmailCheck(false)
                        } else {
                          setEmailCheck(true)
                        }
                      } catch (err) {
                        console.log(err)
                        setEmailCheck(true)
                      }
                    }}
                  />
                  <span>
                    휴대폰번호가 바뀌게 되면 사용자 확인 용도로 쓰입니다. <br />
                    정확하게 입력해주세요.
                  </span>
                </div>
                <div className='inp_box'>
                  <p style={{ fontSize: '15px', lineHeight: '18px', fontWeight: '500' }}>내 소개</p>
                  <textarea
                    name=''
                    id=''
                    placeholder='소개를 입력해주세요. (50자 이내)'
                    value={myIntro}
                    onChange={(e) => {
                      setMyIntro(e.target.value)
                    }}
                    style={{ background: '#f8f8f8', border: 'none' }}
                  ></textarea>
                </div>
                <div className='inp_box'>
                  <p style={{ fontSize: '15px', lineHeight: '18px', fontWeight: '500' }}>
                    웹사이트
                    {websiteCheck ? <em>사용할 수 없는 URL입니다.</em> : null}
                  </p>
                  <input
                    type='text'
                    placeholder='웹사이트를 입력해주세요.'
                    value={website}
                    // onChange={(e) => {
                    //   setWebsite(e.target.value);
                    // }}
                    className='profile_edit'
                    onChange={(e) => {
                      const url = e.target.value
                      setWebsite(url)
                      const regex = /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w .-]*)*\/?$/
                      setWebsiteCheck(!regex.test(url))
                      if (e.target.value === '') {
                        setWebsiteCheck(false)
                      }
                    }}
                  />
                </div>
                <div className='inp_box'>
                  <p style={{ fontSize: '15px', lineHeight: '18px', fontWeight: '500' }}>국가</p>
                  <div className='inp_nation profile_edit'>
                    <input type='text' value={'대한민국'} readOnly disabled className='profile_edit' />
                  </div>
                </div>
                <div className='inp_box'>
                  <p style={{ fontSize: '15px', lineHeight: '18px', fontWeight: '500' }}>휴대폰 번호</p>
                  <div className='inp_phone'>
                    <input type='text' className='profile_edit' value={phone} readOnly disabled />
                    <button
                      type='button'
                      onClick={() => {
                        setPhoneChangeModal(true)
                      }}
                    >
                      수정
                    </button>
                  </div>
                </div>
              </div>
              <button
                className='btn_withdrawal'
                onClick={() => {
                  setWithdrawal(true)
                }}
              >
                회원탈퇴하기
              </button>
              <div style={{ display: 'flex', justifyContent: 'center', gap: '7px', marginBottom: '24px' }}>
                <button
                  type='button'
                  className='btn_save'
                  style={{
                    background: '#F3F3F3',
                    color: '#191919',
                    width: '160px',
                    cursor: 'pointer',
                  }}
                  onClick={() => {
                    navigate('/myshopping')
                  }}
                >
                  취소
                </button>
                <button
                  type='button'
                  className='btn_save'
                  style={{
                    background: isModifyReady ? '#191919' : '#F4F4F4',
                    color: isModifyReady ? '#fff' : '#ccc',
                    width: '160px',
                    cursor: 'pointer',
                  }}
                  onClick={() => {
                    if (!isModifyReady) return
                    // if (!nicknameCheck && !emailCheck) {
                    postUpdateUser(email, nickName, selectImage, myIntro, website, phone, verificationCheckCode)
                      .then((res) => {
                        //@ts-ignore
                        const refresh = JSON.parse(
                          //@ts-ignore
                          window.localStorage.getItem('aboutRefreshToken')
                        )

                        postRefresh(refresh, os).then((res) => {
                          setIsToast(true)
                          setToastMessage('프로필 수정이 완료되었습니다.')
                          //@ts-ignore
                          window.localStorage.setItem(`aboutAccessToken`, JSON.stringify(res.data.accessToken))

                          postOpenid(res.data.accessToken)
                            .then((res) => {
                              window.localStorage.setItem(`accessToken`, JSON.stringify(res.data.accessToken))
                              navigate('/myshopping')

                              window.location.reload()
                            })
                            .catch((err) => console.log(err))
                        })
                      })
                      .catch((err) => {})
                  }}
                >
                  저장
                </button>
              </div>
            </div>
          </div>
          {pictureModal ? (
            isMobile ? (
              <PictureModal
                profileImages={profileImages}
                setPictureModal={setPictureModal}
                setSelectImage={setSelectImage}
                profileImage={profileImage}
                pictureModal={pictureModal}
              />
            ) : (
              <PictureCenterModal
                profileImages={profileImages}
                setPictureModal={setPictureModal}
                setSelectImage={setSelectImage}
                profileImage={profileImage}
                pictureModal={pictureModal}
              />
            )
          ) : null}
          {phoneChangeModal
            ? isMobile && (
                <PhoneChangeModal
                  setVerificationCheckCode={setVerificationCheckCode}
                  setPhone={setPhone}
                  setIsModal={setPhoneChangeModal}
                  isModal={phoneChangeModal}
                ></PhoneChangeModal>
              )
            : null}
          {withdrawal
            ? isMobile && <WithdrawalModal setIsModal={setWithdrawal} isModal={withdrawal}></WithdrawalModal>
            : null}
        </div>
      </div>
      {phoneChangeModal
        ? !isMobile && (
            <PhoneChangeCenterModal
              setVerificationCheckCode={setVerificationCheckCode}
              setPhone={setPhone}
              setIsModal={setPhoneChangeModal}
              isModal={phoneChangeModal}
            ></PhoneChangeCenterModal>
          )
        : null}
      {withdrawal
        ? !isMobile && <WithdrawalCenterModal setIsModal={setWithdrawal} isModal={withdrawal}></WithdrawalCenterModal>
        : null}
    </>
  )
}
